<label class="step-header">ACCESS FEE RULE: {{planData.planName}}</label>
<button *ngIf="showDeactivate" mat-raised-button class="btn-primary float-right" (click)="deactivateAccessFeeRule()">Deactivate</button>
<div class="divider"></div>

<div class="view-container main-container shadow-all">
  <div>
    <form>
      <div class="row padding-60 flex-row margin-h-10" *ngIf="planData">
        <div class="flex-grow-basis">
          <p class="preview-text preview-text-color">Name</p>
          <p class="preview-text preview-terms-color">{{planData.planName}}</p>
        </div>
        <div class="flex-grow-basis">
          <p class="preview-text preview-text-color">City</p>
          <p class="preview-text preview-terms-color">{{planData.city}}</p>
        </div>
        <div class="flex-grow-basis">
          <p class="preview-text preview-text-color">Services</p>
          <p class="preview-text preview-terms-color">{{planData.services}}</p>
        </div>
        <div class="flex-grow-basis">
          <p class="preview-text preview-text-color">Zones</p>
          <p class="preview-text preview-terms-color">{{planData.zones || '--'}}</p>
        </div>
        <div class="flex-grow-basis">
          <p class="preview-text preview-text-color">User Selectors</p>
          <p class="preview-text preview-terms-color">{{planData.userSelectors || '--'}}</p>
        </div>
        <div class="flex-grow-basis" *ngIf="planData.createdBy">
          <p class="preview-text preview-text-color">Created By</p>
          <p class="preview-text preview-terms-color">{{planData.createdBy}}</p>
        </div>
        <div class="flex-grow-basis" *ngIf="planData.approvedBy">
          <p class="preview-text preview-text-color">Approved By</p>
          <p class="preview-text preview-terms-color">{{planData.approvedBy}}</p>
        </div>
        <div class="flex-grow-basis">
          <p class="preview-text preview-text-color">Active</p>
          <p class="preview-text preview-terms-color">{{planData.active}}</p>
        </div>
        <div class="flex-grow-basis">
          <p class="preview-text preview-text-color">Priority</p>
          <p class="preview-text preview-terms-color">{{planData.priority}}</p>
        </div>
        <div class="divider"></div>
        <div class="flex-grow-basis">
            <p class="preview-text preview-text-color">Start Date</p>
            <p class="preview-text preview-terms-color">{{planData.startDate}}</p>
        </div>
        <div class="flex-grow-basis">
          <p class="preview-text preview-text-color">End Date</p>
          <p class="preview-text preview-terms-color">{{planData.endDate}}</p>
        </div>

        <div class="divider"></div>
          <div class="flex-grow-basis">
            <table class="spacing-table">
              <thead>
                <tr>
                  <th class="preview-text preview-text-color">Minimum Rides</th>
                  <th class="preview-text preview-text-color">Charged Fee</th>
                  <th class="preview-text preview-text-color">StrikeOut Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let tier of planData.tiers">
                  <td class="preview-text preview-terms-color">{{tier.minValue}}</td>
                  <td class="preview-text preview-terms-color">{{tier.amount}}</td>
                  <td class="preview-text preview-terms-color">{{tier.strikeOutAmount || '--'}}</td>
                </tr>
              </tbody>
            </table>
          </div>

      </div>
    </form>
  </div>
  <app-authz-access-hint-footer [authzAccessHint]="authzAccessHint"></app-authz-access-hint-footer>
</div>